import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './wrike-folder-meeting.types';

export const wrikeFolderMeetingSelectors = {
  ...generateResourceSelectors<types.IWrikeFolderMeeting>((state) => state.resource.wrikeFolderMeeting),
};
